import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { BaseInjectorService } from "src/app/base/base-service.injector";
import { IonModal, ModalController } from "@ionic/angular";
import { SearchUsersComponent } from "../../search-users/search-users.component";
import { AppService } from "src/app/app.service";
import { ModalCommunicationService } from "src/app/services/modal-communication.service";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import * as _ from 'lodash';
import { where } from "firebase/firestore";
@Component({
  selector: 'i-discussed-user-list',
  templateUrl: './i-discussed-user-list.component.html',
  styleUrls: ['./i-discussed-user-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IDiscussedUserListComponent
  extends BaseInjectorService
  implements OnInit, OnDestroy {
  @ViewChild("searchModal", { static: true }) searchModal!: IonModal;
  siteAreaOwnerForm = new FormGroup({});
  model: any = {};
  site_area_owner: FormlyFieldConfig[];
  searchUsersList: any = [];
  copyUserList: any;
  isSelected: false;
  category: any;
  searching: boolean = false;
  searchControl: any;
  searchTerm: string = '';
  area_owner: any;
  site_manager: any;
  lastFiveDiscussedUser: any = [];
  lastFiveAssignedUserList: any[] = [];
  showSkeleton: boolean = true;
  keyboardHeight: number = 0;
  private keyboardListener: any;
  pageTitle='Select user';
  showBackBtn = true;

  // Callback function for component-specific search handling
  onSearchUserLists: () => void;
  zoneOwner: any;

  constructor(
    private changeDetection: ChangeDetectorRef,
    private modalCtrl: ModalController,
    public appService: AppService,
    private modalCommunicationService: ModalCommunicationService
  ) {
    super();
    this.searchControl = new FormControl();
  }

  ngOnInit() {
    // console.log("siteManager Details = " + JSON.stringify(this.site_manager));
    // console.log("area owner detail = " + this.appService?.currentTour?.currentBogTourInfo?.area_owner_email);
    this.site_area_owner = [
      {
        key: "siteManager",
        type: "input",
        className: "add-qr-custom-input",
        props: {
          appearance: "outline",
          label: this.translate.instant("AREA_MANAGEMENT.SITE_MANAGER"),
          readonly: true,
        },
      },
      {
        key: "areaOwner",
        type: "input",
        className: "add-qr-custom-input",
        props: {
          appearance: "outline",
          label: this.translate.instant("TOURLIST.AREA_OWNER"),
          readonly: true,
        },
      },
    ];

    this.setupKeyboardListeners();
    // setTimeout(() => {
    //   if (this.site_manager) {
    //     if (this.site_manager.id != undefined)
    //       this.site_area_owner[0].formControl.setValue(this.site_manager.id);
    //     else
    //       this.site_area_owner[0].formControl.setValue(
    //         "No site manager Assigned."
    //       );
    //   } else {
    //     this.site_area_owner[0].formControl.setValue(
    //       "No site manager Assigned."
    //     );
    //   }

    //   if (this.area_owner) {
    //     if (this.area_owner.Email != undefined) {
    //       this.site_area_owner[1].formControl.setValue(this.area_owner.Email);
    //     } else {
    //       this.site_area_owner[1].formControl.setValue(
    //         "No area owner Assigned."
    //       );
    //     }
    //   } else {
    //     this.site_area_owner[1].formControl.setValue("No area owner Assigned.");
    //   }
    //   this.showSkeleton = false;
    // }, 500);

    this.site_area_owner[0].props.focus = ($eventq) => {
      if (this.site_manager.Email != undefined) {
        this.closePopup({ status: "ok", data: this.site_manager });
      }
    };
    this.site_area_owner[1].props.focus = ($event) => {
      if (this.area_owner.Email != undefined) {
        this.closePopup({ status: "ok", data: this.area_owner });
      }
    };

    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((searchText) => {
        // this.setSearchedPolicy(searchText);
      });
  }

  setupKeyboardListeners() {
    if (Capacitor.isNativePlatform()) {
      this.keyboardListener = Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight;
        // Scroll the search input into view
        setTimeout(() => {
          const searchInput = document.getElementById('searchText');
          if (searchInput) {
            searchInput.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        }, 300);
      });

      Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0;
      });
    }
  }

  ngOnDestroy() {
    if (this.keyboardListener) {
      this.keyboardListener.remove();
    }
  }
  async ionViewDidEnter() {
    this.setGAD_Employees();
    this.searchControl.setValue('');

    // this.setSearchedPolicy("");
    this.getLastFiveDiscussedUser();
    this.getLastFiveAssignedUser();
  }
  onSearchInput() {
    this.searching = true;
  }
  async setGAD_Employees() {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    let shield_info = await this.lhStorage.get("currentRapid");
    let filtered = tmp_GAD_emp_list.filter(
      (obj: any) => obj.Country == shield_info.Country
    );
    let usersList = filtered[0].GAD_employee_list.filter(
      (obj: any) => obj.full_name_lower != undefined
    );
    let searchUsersList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
    this.copyUserList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
    this.searchService.item = searchUsersList;
    this.isSelected = false;
  }
  // async setSearchedPolicy(searchText) {
  //   this.searchUsersList = [];
  //   this.searchTerm = "";
  //   if (searchText != "") {
  //     this.searchTerm = searchText;
  //     const query = this.searchTerm.toLowerCase(); // Get the search query
  //     let updatedUsers = this.copyUserList.filter((item) => {
  //       return (
  //         item.Email.toLowerCase().includes(query) ||
  //         item.full_name_lower.toLowerCase().includes(query)
  //       );
  //     });
  //     this.searching = false;
  //     if (updatedUsers.length == 0) {
  //     }
  //     this.searchUsersList = updatedUsers;
  //   }
  //   this.changeDetection.detectChanges();
  // }
  userSelected(usr) {
    console.log('User selected in modal:', usr);
    // Use setTimeout to ensure the click event completes before dismissing
    setTimeout(() => {
      this.closePopup({ status: "ok", data: usr });
    }, 0);
  }
  closeBtnClick() {
    this.closePopup({ status: "cancel", data: "" });
  }
  closePopup(obj) {
    console.log('Closing popup with data:', obj);
    if (obj?.status == "searchUser") {
      // Check if a callback function was provided
      if (this.onSearchUserLists && typeof this.onSearchUserLists === 'function') {
        // Use the callback function for component-specific handling
        this.onSearchUserLists();
      } else {
        // Fallback to global service for backward compatibility
        this.modalCommunicationService.triggerSearchUserLists();
      }
      this.modalController.dismiss(obj);
    } else {
      // Immediately dismiss without any callbacks or delays
      this.modalController.dismiss(obj).then(() => {
        console.log('Modal dismissed successfully');
      }).catch(err => {
        console.error('Error dismissing modal:', err);
      });
    }
  }
  callAddContractor() {
    this.closePopup({ status: "add contractor", data: "" });
  }
  // Handle "Search in country directory" click - show country directory
  onCountryDirectoryClick() {
    setTimeout(() => {
      this.closePopup({ status: "ok", data: this.site_manager });
    }, 0);
  }

  async onAreaOwnerClick() {
    let zoneOwnerEmail:any=this.appService.currentTour.currentBogTourInfo.zoneConfiguration.zoneOwner.email
    let filteredAssignedTo = _.filter(this.appService.appData.usersByCountry, (u) => {
      // console.log("🚀 ~ ActionService ~ filteredAssignedTo ~ u:", u)
      return u.email == zoneOwnerEmail;
    });
    if (filteredAssignedTo.length > 0) {
      setTimeout(() => {
        this.closePopup({ status: "ok", data: filteredAssignedTo[0] });
      }, 0);
    }else{
      if(this.appService.connectionState){
          await this.overlayService.presentLoading(
            this.createLoaderOptions(this.translate.instant('APP_LOADING_LABEL'))
          );
          const docInfo: any = await this.lhFire.queryCollection(
            'icare_person_master',
            where('id', '==', zoneOwnerEmail)
          );
          const docData: any = docInfo.docs?.[0]?.data() || {};
          let full_name_lower=docData.first_name.toLowerCase()+" "+docData.last_name.toLowerCase()
          let obj={
            Email: docData.id,
            First_Name: docData.first_name,
            Fname: docData.first_name,
            Full_Name: docData.first_name + ' '+ docData.last_name,
            Last_Name: docData.last_name,
            Lname: docData.last_name,
            assignedTo:docData.id,
            assignedToName: docData.first_name + ' '+ docData.last_name,
            assignedToPersonUniqueId: docData.unique_id,
            full_name_lower: full_name_lower,
            id: docData.id
          }
           setTimeout(() => {
            this.closePopup({ status: "ok", data: obj });
          }, 0);
         await this.overlayService.dismissLoading();
      }
    }
  }
  async getLastFiveAssignedUser() {
    let lastFiveAssignedUserList = await this.lhStorage.get(
      "lastFiveAssignedToUsers"
    );
    // Filter out entries without Email value
    this.lastFiveAssignedUserList = lastFiveAssignedUserList
      ? lastFiveAssignedUserList.filter((user: any) => user?.Email && user.Email.trim() !== '')
      : [];

  }
  async getLastFiveDiscussedUser() {
    let lastFiveDisucssedUserList = await this.lhStorage.get(
      "lastFiveIDiscussedUsers"
    );
    // Filter out entries without Email value
    this.lastFiveDiscussedUser = lastFiveDisucssedUserList
      ? lastFiveDisucssedUserList.filter((user: any) => user?.Email && user.Email.trim() !== '')
      : [];
  }

  async onSearchClick() {
    this.closePopup({ status: "searchUser", data: "" });
  }

  closeSearchModal() {
    this.modalController.dismiss();
    this.searchModal.dismiss();
  }
}



